import React from 'react';
import Loading from './Loading';
import './CenteredLoading.css';

const CenteredLoading = () => (
    <div className="centered-loading">
        <Loading />
    </div>
);

export default CenteredLoading;